import type { LucideIcon } from "lucide-react";

import {
  getCatalogServiceIcon,
  normalizeServiceIconColor,
  serviceIconBadgeStyle,
} from "@/lib/services/icon-catalog";

export function getServiceIcon(
  iconName: string | null,
  categorySlug?: string,
): LucideIcon {
  return getCatalogServiceIcon(iconName, categorySlug);
}

const CATEGORY_ACCENTS: Record<string, string> = {
  biztositas: "bg-sky-100 text-sky-700",
  "it-es-eszkozbeszerzes": "bg-emerald-100 text-emerald-700",
  "jogi-tanacsadas": "bg-violet-100 text-violet-700",
  konyveles: "bg-amber-100 text-amber-800",
  palyazatok: "bg-orange-100 text-orange-800",
  praxismenedzsment: "bg-blue-100 text-blue-700",
  shield: "bg-sky-100 text-sky-700",
  monitor: "bg-emerald-100 text-emerald-700",
  scale: "bg-violet-100 text-violet-700",
  calculator: "bg-amber-100 text-amber-800",
  landmark: "bg-orange-100 text-orange-800",
  briefcase: "bg-blue-100 text-blue-700",
};

export function getServiceAccent(
  iconName: string | null,
  categorySlug: string,
) {
  return (
    CATEGORY_ACCENTS[iconName ?? ""] ??
    CATEGORY_ACCENTS[categorySlug] ??
    "bg-primary/10 text-primary"
  );
}

export function getServiceIconTone(
  iconColor: string | null | undefined,
  iconName: string | null,
  categorySlug: string,
) {
  if (normalizeServiceIconColor(iconColor)) {
    return {
      className: undefined as string | undefined,
      style: serviceIconBadgeStyle(iconColor),
    };
  }

  return {
    className: getServiceAccent(iconName, categorySlug),
    style: undefined,
  };
}
